<div class="d-flex align-items-center" mat-dialog-title>
    <div class="spacer title">
        Bewerk {{ title }}
        @if ((Roles.Codalt | hasRole) && entity?.afas_employee_id) {
            (Afas: {{ entity?.afas_employee_id }})
        }
    </div>
    <div>
        <button (click)="close()" mat-icon-button tabindex="-1"><i class="fas fa-times"></i></button>
    </div>
</div>

@if (form) {
    <div class="row" mat-dialog-content>
        <form [formGroup]="form">
            <mat-form-field class="col-24" id="name">
                <mat-label>Naam</mat-label>

                <input
                    formControlName="name"
                    matInput
                    name="name"
                    placeholder="Naam"
                    type="text"
                    autocomplete="entity-names" />

                <mat-error>Dit veld is verplicht</mat-error>
            </mat-form-field>

            <div class="col-24" id="entitytypes">
                <ng-select
                    class="ng-select-fill"
                    [clearable]="true"
                    [multiple]="true"
                    formControlName="entitytypes"
                    placeholder="Types">
                    @for (type of entitytypeList; track type) {
                        <ng-option [value]="type.key">{{ type.name }}</ng-option>
                    }
                </ng-select>
            </div>

            @if (
                form.controls.entitytypes.value?.includes(EntityTypeCode.AsfaltTeam) &&
                (this.environment.roles.Codalt | hasRole)
            ) {
                <div class="col-24" id="roles">
                    <ng-select
                        class="ng-select-fill"
                        [clearable]="true"
                        [multiple]="true"
                        formControlName="roles"
                        placeholder="Rollen">
                        @for (role of roles; track role) {
                            <ng-option [value]="role.key">{{ role.name }}</ng-option>
                        }
                    </ng-select>
                </div>
            }

            @if (viewState.driver) {
                <div class="col-24" id="driver_user_id">
                    <ng-select
                        class="ng-select-fill"
                        [clearable]="true"
                        formControlName="driver_user_id"
                        placeholder="Voorkeurschauffeur">
                        @for (driver of truckDrivers; track driver) {
                            <ng-option [value]="driver.id">{{ driver.name }}</ng-option>
                        }
                    </ng-select>
                </div>
            }

            @if (viewState.preferredTeam) {
                <div class="col-24" id="team_entity_id">
                    <ng-select
                        class="ng-select-fill"
                        [clearable]="true"
                        formControlName="team_entity_id"
                        placeholder="Voorkeursploeg">
                        @for (entity of entityTeams; track entity) {
                            <ng-option [value]="entity.id">{{ entity.name }}</ng-option>
                        }
                    </ng-select>
                </div>
            }
            <div class="row">
                @if (viewState.truck) {
                    <div class="col" id="truck_entity_id">
                        <ng-select
                            class="ng-select-fill"
                            [clearable]="true"
                            formControlName="truck_entity_id"
                            placeholder="Trekkend voertuig">
                            @for (entity of entityTrucks; track entity) {
                                <ng-option [value]="entity.id">{{ entity.name }}</ng-option>
                            }
                        </ng-select>
                    </div>
                }

                @if (viewState.lowloader) {
                    <div class="col" id="lowloader_entity_id">
                        <ng-select
                            class="ng-select-fill"
                            [clearable]="true"
                            formControlName="lowloader_entity_id"
                            [placeholder]="lowloaderPlaceholder">
                            @for (entity of entityLowloaders; track entity) {
                                <ng-option [value]="entity.id">{{ entity.name }}</ng-option>
                            }
                        </ng-select>
                    </div>
                }
            </div>

            @if (viewState.employees) {
                <div class="col-24" id="default_employees">
                    <ng-select
                        class="ng-select-fill"
                        [multiple]="true"
                        [clearable]="true"
                        formControlName="default_employees"
                        placeholder="Standaard personeel">
                        @for (employee of employees; track employee) {
                            <ng-option [value]="employee.id">{{ employee.name }} ({{ employee.function }})</ng-option>
                        }
                    </ng-select>
                </div>
            }

            @if (viewState.performer) {
                <div class="col-24" id="default_performer_id">
                    <ng-select
                        class="ng-select-fill"
                        [clearable]="true"
                        formControlName="default_performer_id"
                        placeholder="Standaard {{ environment.executorName }}">
                        @for (employee of executors; track employee) {
                            <ng-option [value]="employee.id">
                                {{ employee.name }}
                            </ng-option>
                        }
                    </ng-select>
                </div>
            }

            @if (viewState.asphaltPerformer) {
                <div class="col-24" id="default_asphalt_performer_id">
                    <ng-select
                        class="ng-select-fill"
                        [clearable]="true"
                        formControlName="default_asphalt_performer_id"
                        placeholder="Standaard asfaltuitvoerder">
                        @for (employee of asphaltExecutors; track employee) {
                            <ng-option [value]="employee.id">
                                {{ employee.name }}
                            </ng-option>
                        }
                    </ng-select>
                </div>
            }

            <div class="row">
                <mat-form-field class="col">
                    <mat-label>Beschikbaar vanaf</mat-label>

                    <input
                        [matDatepicker]="pickerStart"
                        [max]="form.get('enddate').value"
                        (focus)="pickerStart.open()"
                        formControlName="begindate"
                        matInput
                        placeholder="Beschikbaar vanaf" />

                    <mat-datepicker-toggle [for]="pickerStart" matSuffix />

                    <mat-datepicker #pickerStart />

                    <mat-error
                        [control]="form.get('begindate')"
                        customMessage="{{ title }} {{ entity.name }} is al ingepland voor deze datum" />
                </mat-form-field>

                <mat-form-field class="col">
                    <mat-label>Beschikbaar tot</mat-label>

                    <input
                        [matDatepicker]="pickerEnd"
                        [min]="form.get('begindate').value"
                        (focus)="pickerEnd.open()"
                        formControlName="enddate"
                        matInput
                        placeholder="Beschikbaar tot" />

                    <mat-datepicker-toggle [for]="pickerEnd" matSuffix />

                    <mat-datepicker #pickerEnd />

                    <mat-error
                        [control]="form.get('enddate')"
                        customMessage="{{ title }} {{ entity.name }} is al ingepland na deze datum" />
                </mat-form-field>
            </div>

            @if (viewState.vkm) {
                <div class="col-24">
                    <div class="row">
                        <mat-form-field class="col-8">
                            <mat-label>Vervangingsprijs</mat-label>

                            <input
                                [decimalInput]="2"
                                appDecimalInput
                                formControlName="price"
                                matInput
                                placeholder="Vervangingsprijs"
                                type="text" />

                            <mat-error [control]="form.get('price')" />
                        </mat-form-field>

                        <mat-form-field class="col-8">
                            <mat-label>Prijs per eenheid</mat-label>

                            <input
                                [decimalInput]="2"
                                appDecimalInput
                                formControlName="price_unit"
                                matInput
                                placeholder="Prijs per eenheid"
                                type="text" />

                            <mat-error [control]="form.get('price_unit')" />
                        </mat-form-field>

                        <mat-form-field class="col-8">
                            <mat-label>Eenheid</mat-label>

                            <input formControlName="unit" matInput placeholder="Eenheid" type="text" />

                            <mat-error [control]="form.get('unit')" />
                        </mat-form-field>

                        <mat-form-field class="col-8">
                            <mat-label>Prijs voor plotten</mat-label>

                            <input
                                [decimalInput]="2"
                                appDecimalInput
                                formControlName="price_plotten"
                                matInput
                                placeholder="Prijs voor plotten"
                                type="text" />
                            <mat-error [control]="form.get('price_plotten')" />
                        </mat-form-field>

                        <mat-form-field class="col-8">
                            <input
                                [decimalInput]="0"
                                appDecimalInput
                                formControlName="coupling_clamps"
                                matInput
                                placeholder="Aantal koppelklemmen"
                                type="text" />

                            <mat-error [control]="form.get('coupling_clamps')" />
                        </mat-form-field>

                        <mat-form-field class="col-8">
                            <input
                                [decimalInput]="0"
                                appDecimalInput
                                formControlName="ground_pot"
                                matInput
                                placeholder="Aantal grondpotten"
                                type="text" />

                            <mat-error [control]="form.get('ground_pot')" />
                        </mat-form-field>
                    </div>
                </div>
            }

            @if (viewState.vkm) {
                <mat-form-field class="col-24">
                    <mat-label>Groepering</mat-label>

                    <input formControlName="settle_group" matInput placeholder="Groepering" type="text" />

                    <mat-error [control]="form.get('settle_group')" />
                </mat-form-field>
            } @else {
                <div class="col-24 mb-2">
                    <mat-checkbox formControlName="exclude_driving_hours">
                        Transporttijd niet doorboeken<br />
                        <small>
                            Transporttijd wordt <b>{{ form.get('exclude_driving_hours').value ? 'niet' : 'wel' }}</b>
                            doorgeboekt voor dit materieelstuk
                        </small>
                    </mat-checkbox>

                    <br /><br />

                    Standaard start-/stoplocatie:<br />

                    <mat-checkbox formControlName="default_transport_none">
                        <i class="fa-duotone fa-xmark"></i> Geen
                    </mat-checkbox>

                    <br />

                    <mat-checkbox formControlName="default_transport_home">
                        <i class="fa-duotone fa-house-user"></i> Thuis
                    </mat-checkbox>
                </div>
            }
        </form>

        @if (!viewState.vkm) {
            <div class="col-24">
                <div>
                    <h4>Onbeschikbaarheid</h4>
                </div>

                <table class="table table-center table-add-row table-last-col">
                    <tr>
                        <th>Reden</th>
                        <th class="datetime">Niet beschikbaar vanaf</th>
                        <th class="datetime">Niet beschikbaar tot</th>
                        <th></th>
                    </tr>
                    @for (entityUnavailable of entity.entity_unavailable; track entityUnavailable) {
                        <tr
                            [class.form-submitted]="submitted"
                            [formGroup]="unavailablePlanningForm.get(entityUnavailable)">
                            <td class="text-input">
                                <input
                                    class="row-input"
                                    formControlName="description"
                                    name="description"
                                    placeholder="Reden"
                                    type="text" />
                            </td>

                            <td class="tabledate">
                                <input
                                    [matDatepicker]="pickerStart"
                                    [max]="unavailablePlanningForm.get(entityUnavailable).get('enddate').value"
                                    (focus)="pickerStart.open()"
                                    (click)="pickerStart.open()"
                                    formControlName="begindate"
                                    placeholder="Niet beschikbaar vanaf" />
                                <mat-datepicker #pickerStart />
                            </td>

                            <td class="tabledate">
                                <input
                                    [matDatepicker]="pickerEnd"
                                    [min]="unavailablePlanningForm.get(entityUnavailable).get('begindate').value"
                                    (focus)="pickerEnd.open()"
                                    (click)="pickerEnd.open()"
                                    formControlName="enddate"
                                    matInput
                                    placeholder="Niet beschikbaar tot" />
                                <mat-datepicker #pickerEnd />
                            </td>

                            <td>
                                <button
                                    class="delete-button"
                                    (click)="deleteUnavailable($event, entityUnavailable)"
                                    color="warn"
                                    mat-icon-button>
                                    <mat-icon class="fas fa-trash" />
                                </button>
                            </td>
                        </tr>

                        @if (
                            unavailablePlanningForm.get(entityUnavailable).errors &&
                            unavailablePlanningForm.get(entityUnavailable).errors.notAvailable
                        ) {
                            <tr>
                                <td colspan="3">
                                    <mat-error
                                        [control]="unavailablePlanningForm.get(entityUnavailable)"
                                        customMessage="{{ title }} {{ entity.name }} is al ingepland in deze periode" />
                                </td>

                                <td></td>
                            </tr>
                        }
                    }
                    <tr>
                        <td colspan="3">
                            <button class="w-100" (click)="addUnavailable()" color="primary" mat-button>
                                Onbeschikbaarheid toevoegen <i class="fas fa-plus"></i>
                            </button>
                        </td>

                        <td></td>
                    </tr>
                </table>
            </div>
        }

        <div class="col">
            <app-planning-table [title]="entity?.name" [entityId]="entity?.id" />
        </div>
    </div>
}

<div mat-dialog-actions>
    <div class="d-flex justify-content-between w-100">
        <button (click)="close()" mat-button>Annuleren</button>

        <button [disabled]="saving" (click)="save()" color="primary" mat-raised-button>
            Opslaan
            @if (saving) {
                <i class="fas fa-circle-notch fa-spin"></i>
            }
        </button>
    </div>
</div>
